import React from 'react';
import { Text, Title } from '@mantine/core';

import { ProductSalesLineGraph } from '../graphs';
import { Request } from '../../codegen/graphql';
import { useProductSalesScope } from '../../hooks/useProductSalesScope';
import {
    getPriceChangeScope,
    getSuggestedStoreIds,
} from '../../helpers/priceChangeScope';
import { useUser } from '../../hooks/useUser';

type Props = {
    flatRequest: Request | null;
};

function RequestProductSales({ flatRequest }: Props) {
    const { isStoreManager } = useUser();
    const salesScope = useProductSalesScope({
        advertisingZoneId: flatRequest?.advertisingZoneId,
        priceChangeScope: getPriceChangeScope(flatRequest),
        suggestedStoreIds: getSuggestedStoreIds(flatRequest),
    });

    return (
        <div className="mt-10 flex flex-1 flex-col gap-4">
            <div className="flex flex-col gap-1">
                <Title order={4}>Product Sales</Title>
                <Text size="sm" c="dimmed">
                    Last 4 completed financial weeks vs the same weeks last year
                </Text>
            </div>
            <ProductSalesLineGraph
                key={flatRequest?.id}
                request={flatRequest}
                salesScope={salesScope}
                showChart={!isStoreManager}
            />
        </div>
    );
}

export default RequestProductSales;
